module.exports = __webpack_public_path__ + "img/GT.ShallowFoundation.RaftFoundation.UnpiledRaft1m.a5864575.png";